import Vue from 'vue'
import App from './MedicareApp'
import store from "@/store"
import Buefy from 'buefy'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {setRetriever} from "@/paths/helpers";

Vue.use(Buefy)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  render: h => h(App),
})

setRetriever("dae71f364b191cf9ad345bfd5debce08")
